<template>
  <nav class="nav">
    <ul class="nav__list container">
      <li
        class="nav__item item"
        v-for="(item, key) in nav"
        :class="{ item_expanded: dropdownShown === key }"
        :key="key"
      >
        <router-link
          :is="itemHasMobileDropdown(item) ? 'span' : 'router-link'"
          @click.native.capture="onLinkClick($event, item.os)"
          :to="item.link ? item.link : `/?compatibility=${item.os}`"
        >
          <span class="item__heading">
            <span class="item__label label">
              <img class="label__icon" v-if="item.icon" :src="item.icon" :width="item.iconWidth" />
              <span class="label__text" v-if="item.label">
                {{ item.label }}
              </span>
            </span>

            <span
              v-if="item.text"
              class="item__text"
              >{{ item.text }}</span
            >
            <!-- <img
              v-if="item.os"
              class="item__icon"
              src="@/assets/icon-dropdown.svg"
            /> -->
          </span>
        </router-link>

        <!-- <ul
          v-if="item.os"
          ref="dropdown"
          class="item__dropdown dropdown"
        >
          <li>
            <router-link
              class="dropdown__link"
              :to="`/search/?type=${item.type}`"
              @click.native="hideDropdown"
            >
              {{ $t('ALL_CATEGORIES') }}
            </router-link>
          </li>
          <li v-for="(child, key) in genres" :key="key">
            <router-link
              class="dropdown__link"
              :to="`/search/?type=${item.type}&genre=${key}`"
              @click.native="hideDropdown"
            >
              {{ child.name }}
            </router-link>
          </li>
        </ul> -->
      </li>
    </ul>
    <div ref="extender" :style="{ height: extenderHeight }"></div>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      extenderHeight: 0,
      dropdownShown: -1,
    };
  },
  computed: {
    nav() {
      const returnArray = [{
        label: `iPhone ${this.$t('APPS')}`,
        os: 'ios',
      },
      {
        label: `iPad ${this.$t('APPS')}`,
        os: 'ipados',
      },
      {
        icon: require('@/assets/icon-apple.svg'),
        label: `tv ${this.$t('APPS')}`,
        os: 'tvos',
      }];

      if (this.BRAND_CONFIG.domain !== 'dbservices.to') {
        returnArray.push({
          icon: require('@/assets/icon-repo.png'),
          iconWidth: 14,
          text: this.$t('REPOSITORIES'),
          link: '/repos',
        },
        {
          icon: require('@/assets/icon-requests.svg'),
          text: this.$t('REQUESTS'),
          link: '/requests',
        });
      }
      return returnArray;
    },
    genres() {
      return this.$store.getters.genres.official;
    },
    isMobileDropdown() {
      return window.innerWidth <= 1250;
    },
  },
  methods: {
    onLinkClick(e, os) {
      if (!os || this.$route.name !== 'home') {
        return;
      }

      e.preventDefault();
      e.stopImmediatePropagation();

      this.$router.push({ path: this.$route.fullPath, query: { compatibility: os } });
    },
    itemHasMobileDropdown(item) {
      return this.isMobileDropdown && this.genres[item.type];
    },
    toggleDropdown(key, e) {
      if (!this.isMobileDropdown) {
        return;
      }

      if (e.path.some(el => typeof el.className === 'string' && el.className.split(' ').includes('item__dropdown'))) {
        return;
      }

      e.preventDefault();

      if (this.dropdownShown === key) {
        this.dropdownShown = -1;
        this.extenderHeight = 0;
        return;
      }

      this.dropdownShown = key;
      this.$nextTick(() => {
        const dropdown = this.$refs.dropdown.find(el => el.offsetHeight !== 0);
        if (dropdown) {
          this.extenderHeight = `${dropdown.offsetHeight + 20}px`;
        }
      });
    },
    hideDropdown() {
      this.dropdownShown = -1;
      this.extenderHeight = 0;
    },
    handleDropdown(e) {
      if (e.path.some(el => typeof el.className === 'string' && el.className.split(' ').includes('nav__item'))) {
        return;
      }
      this.dropdownShown = -1;
      this.extenderHeight = 0;
    },
    clickThrough(e) {
      this.$refs.extender.style.display = 'none';
      this.$nextTick(() => {
        document.elementFromPoint(e.clientX, e.clientY).click();
        this.$refs.extender.style.display = 'block';
      });
    },
  },
  mounted() {
    document.body.addEventListener('click', this.handleDropdown);
    this.$refs.extender.addEventListener('click', this.clickThrough);
  },
  destroyed() {
    document.body.removeEventListener('click', this.handleDropdown);
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables";

.nav {
  position: absolute;
  z-index: 5;
  top: 87px;
  left: 0;
  right: 0;
  background-image: linear-gradient(var(--navigation-bg), var(--navigation-bg));
  background-size: 100% 47px;
  background-repeat: no-repeat;
  scrollbar-width: none;
  -ms-overflow-style: none;

  @include notebook {
    width: 100vw;
    overflow: scroll;
    top: 61px;
  }

  &::-webkit-scrollbar {
    width: 0 !important;
    display: none !important;
  }

  &__list {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
  }

  &__item {
    &:last-child {
      @include notebook {
        padding-right: 8px;
      }
    }

    @include notebook {
      margin-right: 15px;
    }
  }
}

.item {
  padding: 10px 0;
  position: relative;

  @mixin expand {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    height: 4px;
    background-color: $primary;
  }

  &_expanded:before {
    @include expand;
  }

  &:hover:after {
    @include desktop-only {
      content: "";
      display: block;
      position: absolute;
      left: 0;
      right: 0;
      bottom: -8px;
      height: 8px;
    }
  }

  &:hover:before {
    @include desktop-only {
      @include expand;
    }
  }

  &__heading {
    color: var(--text-tertiary);
    position: relative;
    display: flex;
    height: 27px;
  }

  &__label {
    margin-right: 8px;

    & + .item__icon {
      margin-left: -2px;
    }
  }

  &__text {
    display: flex;
    align-items: center;
    font-weight: 500;
    white-space: nowrap;
  }

  &__icon {
    margin-left: 5px;
    position: relative;
    top: 1px;
    width: 8px;
  }

  &__dropdown {
    display: none;
  }

  &_expanded .item__dropdown {
    display: block;
  }

  &:hover &__dropdown {
    @include desktop-only {
      display: block;
    }
  }
}

.label {
  white-space: nowrap;
  display: flex;
  font-weight: 600;
  padding: 5px 7px;
  background-color: var(--bg);
  border: 1px solid var(--tertiary-accent);
  border-radius: 3px;
  align-items: center;

  &__icon {
    filter: var(--img-filter);
  }

  &__icon + &__text {
    margin-left: 4px;
  }
}

.dropdown {
  position: absolute;
  top: 54px;
  left: -15px;
  border-radius: 4px;
  background-color: var(--bg);
  box-shadow: 0 2px 8px 0 var(--shadow-color);
  max-height: 400px;
  overflow-y: scroll;

  @include notebook {
    left: -5px;
    top: 52px;
    transition: box-shadow 0.1s;
  }

  &__link {
    display: block;
    white-space: nowrap;
    padding: 5px 15px;
    line-height: 20px;
    color: var(--text-primary);
    font-weight: 400;
    max-width: 230px;
    overflow: hidden;
    text-overflow: ellipsis;

    &:hover {
      background-color: var(--lighter-primary);
    }
  }
}
</style>
